// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","tagsSectionsList":"_2PS4KeeIYrN9YfbQ6Scue0","tagsList":"_2anVzVVekwulLEsL8KjjI5","tag":"I-7iJJuuL7eNQO-Oz9nxp"};